import { AppDefinition } from '../../types/apps';

export const LibraryAppDefinition: AppDefinition = {
  appId: 'library',
  name: 'Library',
  version: '1.0.0',
  description: 'Reference manager for academic papers and documents',
  
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Books',
    phosphorWeight: 'duotone',
    color: '#d97706',
  },
  
  entityTypes: ['Reference'],
  component: 'LibraryApp',
  requiresProps: false,
  requiresEntity: false, // Opens without specific entity
  
  supportedFileTypes: ['.pdf'], // Accepts PDF drops
  
  actions: {},
  experimental: true,
};

